import { render, staticRenderFns } from "./preise.vue?vue&type=template&id=453aec41&scoped=true&"
import script from "./preise.vue?vue&type=script&lang=js&"
export * from "./preise.vue?vue&type=script&lang=js&"
import style0 from "./preise.vue?vue&type=style&index=0&id=453aec41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453aec41",
  null
  
)

export default component.exports